import { render, staticRenderFns } from "./ModuleNeedHelp.vue?vue&type=template&id=291f995e&scoped=true&"
import script from "./ModuleNeedHelp.vue?vue&type=script&lang=js&"
export * from "./ModuleNeedHelp.vue?vue&type=script&lang=js&"
import style0 from "./ModuleNeedHelp.vue?vue&type=style&index=0&id=291f995e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291f995e",
  null
  
)

export default component.exports